var render = function render() {
  var _vm$form, _vm$form2;
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    attrs: {
      "title": "Cliente",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab && !_vm.store.isUpdate
    },
    on: {
      "click": function click() {
        return _vm.store.currentTab = 0;
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cliente",
      "label-for": "nome"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "flex-grow-1",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c('CadastroRapidoSelect', {
    ref: "buscarCliente",
    class: {
      hasErrors: _vm.clienteError,
      inputFilled: _vm.clienteFilled
    },
    attrs: {
      "state": _vm.validateClienteState('nome'),
      "entity-label": "cliente",
      "min-create-length": 3,
      "creating": _vm.criandoCliente,
      "value": _vm.form,
      "options": _vm.clientes
    },
    on: {
      "input": _vm.setCliente,
      "create": _vm.criarClienteInline,
      "search": _vm.onSearchCliente
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(_vm._s(option.codigo) + " - " + _vm._s(option.nome))]), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("CPF: " + _vm._s(_vm.formatCpfCnpj(option.cnpj_cpf)))])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }])
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do cliente ")])], 2)], 1), _c('RiscoClienteGrupo', {
    attrs: {
      "cliente": _vm.form
    }
  })], 1)])], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CPF/CNPJ",
      "label-for": "cnpj_cpf"
    }
  }, [_vm.hasCnpjAlfanumerico(_vm.form.cnpj_cpf) ? _c('b-form-input', {
    key: "".concat(_vm.keyToReRender, "-alfa"),
    attrs: {
      "disabled": "",
      "id": "cnpj_cpf",
      "name": "cnpj_cpf",
      "value": _vm.formatCnpjAlfanumerico(_vm.form.cnpj_cpf)
    }
  }) : _c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ['###.###.###-##', '###.###.###/####-##'],
      expression: "['###.###.###-##', '###.###.###/####-##']"
    }],
    key: "".concat(_vm.keyToReRender, "-numeric"),
    attrs: {
      "disabled": "",
      "id": "cnpj_cpf",
      "name": "cnpj_cpf"
    },
    model: {
      value: _vm.form.cnpj_cpf,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cnpj_cpf", $$v);
      },
      expression: "form.cnpj_cpf"
    }
  })], 1)], 1)], 1), _c('b-row', [(_vm$form = _vm.form) !== null && _vm$form !== void 0 && _vm$form.enderecos ? _c('b-col', {
    attrs: {
      "sm": "10"
    }
  }, [_c('b-form-group', {
    key: _vm.keyToReRender,
    attrs: {
      "label": "Endereço",
      "label-for": "endereco"
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "endereco",
      "name": "endereco",
      "value": _vm.formatEndereco((_vm$form2 = _vm.form) === null || _vm$form2 === void 0 ? void 0 : _vm$form2.enderecos[0])
    }
  })], 1)], 1) : _vm._e()], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Solicitante",
      "label-for": "solicitante"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "solicitante",
      "name": "solicitante",
      "maxlength": "50"
    },
    on: {
      "input": _vm.setSolicitante
    },
    model: {
      value: _vm.solicitante,
      callback: function callback($$v) {
        _vm.solicitante = $$v;
      },
      expression: "solicitante"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "5"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Vendedor",
      "label-for": "vendedor"
    }
  }, [_c('CadastroRapidoSelect', {
    ref: "buscaVendedor",
    attrs: {
      "entity-label": "vendedor",
      "creating": _vm.criandoVendedor,
      "value": _vm.vendedor,
      "options": _vm.vendedores
    },
    on: {
      "input": _vm.setVendedor,
      "create": _vm.criarVendedorInline,
      "open": _vm.onSearchVendedor,
      "search": _vm.onSearchVendedor
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }])
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do vendedor ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.newClient",
      modifiers: {
        "newClient": true
      }
    }],
    ref: "add_buyer",
    staticClass: "btn btn-primary font-weight-bold",
    staticStyle: {
      "font-size": "11px",
      "margin-top": "30px"
    }
  }, [_vm._v(" Cadastro completo ")])])], 1), _c('b-row', [_vm.form.tipo_atacado ? _c('b-col', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "sm": "4"
    }
  }, [_c('span', {
    staticClass: "label label-lg label-inline label-light-warning"
  }, [_vm._v("Tipo Atacado")])]) : _vm._e()], 1), _vm.limiteCreditoAtigindo ? _c('b-row', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('span', {
    staticClass: "label label-lg label-inline label-light-danger"
  }, [_vm._v("Limite de crédito atingido")]), _vm._v(" - "), _c('span', [_c('strong', [_vm._v("Limite: R$ " + _vm._s(_vm.numberToReal(_vm.valorLimiteCredito, 2)))])]), _vm._v(" / "), _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.righttop",
      value: 'O limite de crédito considera contas a receber na situação (Em aberto)',
      expression: "\n          'O limite de crédito considera contas a receber na situação (Em aberto)'\n        ",
      modifiers: {
        "righttop": true
      }
    }]
  }, [_c('strong', [_vm._v("Atingido: R$ " + _vm._s(_vm.numberToReal(_vm.valorLimiteCreditoAtingido, 2)))])])])], 1) : _vm._e(), _vm.listaPreco ? _c('b-row', [_c('b-col', [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v(" Lista de preço aplicada: "), _c('span', {
    staticClass: "font-weight-bold text-primary"
  }, [_vm._v(_vm._s(_vm.listaPreco.descricao))])])])], 1) : _vm._e(), _c('NovoClienteModal', {
    attrs: {
      "modal-id": "newClient"
    },
    on: {
      "selected": _vm.handleNovoClienteSelected
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };